import classNames from 'clsx';
import React from 'react';

import { EventTypeId } from '@swf/sports/types/eventType';

import styles from './BackgroundImage.scss';

interface Props {
  eventTypeId: EventTypeId;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- styles are generated
const backgroundStyles: Partial<Record<EventTypeId, any>> = {
  [EventTypeId.SOCCER]: styles.football,
  [EventTypeId.TENNIS]: styles.tennis,
  [EventTypeId.BASKETBALL]: styles.basketball
};

const BackgroundImage: React.FC<React.PropsWithChildren<Props>> = ({ eventTypeId, children }) => (
  <div className={classNames(styles.container, backgroundStyles[eventTypeId])}>
    <div className={styles.children}>{children}</div>
  </div>
);

export default BackgroundImage;
